import type { CoreFetch } from '~/types/CoreFetch'
import type { Influencer } from '~/types/influencer'

export function provideCreateInfluencer(coreFetch: CoreFetch) {
  return function (
    user: number,
    post: Partial<Influencer>,
  ): Promise<Influencer> {
    return coreFetch.$post(`/influencer/influencer/`, { ...post, user })
  }
}
